import React         from 'react';
import styled        from 'styled-components';
import VXPay         from './VXPay';
import {AppConsumer} from './App.context';

const mediaDesktop = '@media only screen and (min-width: 768px)';
const mediaMobile  = '@media only screen and (max-width: 767px)';

const Styles = {
	button: `
		border-radius: 2px;
	    display: none;
	    font-family: 'Roboto', Tahoma, sans-serif;
	    font-size: 1.4rem;
	    padding: 0.65em 1em 0.55em 1.35em;
	    cursor: pointer;
	    position: relative;
	    text-align: left;
	    text-decoration: none;
	    text-transform: uppercase;
	    transition: all 0.15s linear;
	    vertical-align: top;
	    color: #FFFFFF;
	`,
};

function Logo({isLoggedIn}) {
	const StyledWrapper      = styled.div`
		float: left;
		margin-left: 17px;
		height: 100%;

		${mediaMobile} {
			position: relative;
			float: none;
			margin-left: 0;
			height: ${!isLoggedIn ? '50%' : '100%'};
			border-bottom: 1px solid #FF4D3C;
		}
	`;
	const StyledInnerWrapper = styled.div`
		display: table;
		height: 100%;

		${mediaMobile} {
			display: block;
		    position: absolute;
		    top: 50%;
		    left: 50%;
		    width: auto;
		    height: 25px;
		    transform: translate(-50%, -50%);
		}
	`;
	const StyledLink         = styled.a`
		display: table-cell;
		vertical-align: middle;	
	`;
	const StyledImage        = styled.img`
		height: 34px;

		${mediaMobile} {
			height: 34px;
		}
	`;

	return <StyledWrapper>
		<StyledInnerWrapper>
			<StyledLink href="https://www.visit-x.net">
				<StyledImage src="https://www.visit-x.net/assets/img/logo2.svg"
				             alt="VISIT-X | Deutschlands führende Live Sex Cams &amp; Sexchat Community" />
			</StyledLink>
		</StyledInnerWrapper>
	</StyledWrapper>;
}

function Icon() {
	const StyledIcon = styled.i`
		font-size: 120%;
		margin-right: 10px;
	`;

	return <StyledIcon className="fa fa-user" />;
}

function LoginButton({children}) {
	const StyledButton = styled.button`
		${Styles.button}
		display: inline-block;
	    background-color: #3C3D3E;
	    border: 1px solid #3C3D3E;

		${mediaMobile} {
			width: 100%;
			height: 100%;
			text-align: center;
			text-transform: none;
			font-size: 1.5rem;
		}		
	`;

	return <StyledButton onClick={(e) => VXPay.openLogin()}>
		<Icon />{children}
	</StyledButton>;
}

function LogoutButton({children, onLogoutClick}) {
	const StyledButton = styled.button`
		${Styles.button}
		display: inline-block;
	    background-color: #3C3D3E;
	    border: 1px solid #3C3D3E;

		${mediaMobile} {
			display: none;
		}		
	`;

	return <StyledButton onClick={onLogoutClick}>
		<Icon />{children}
	</StyledButton>;
}

function SignupButtonMobile({children}) {
	const StyledButton = styled.button`
	    ${Styles.button}
		background-color: #1F93E9;
		border: 1px solid #1F93E9;

		${mediaMobile} {
			width:100%;
			height: 100%;
			display: inline-block;
			text-align: center;
			text-transform: none;
			font-size: 1.5rem;
		}		
	`;

	return <StyledButton onClick={(e) => VXPay.openSignup()}>
		<Icon />{children}
	</StyledButton>;
}

function SignupButtonDesktop({children}) {
	const StyledButton = styled.button`
	    ${Styles.button}
		background-color: #1F93E9;
		border: 1px solid #1F93E9;

		${mediaDesktop} {
			display: inline-block;
		}		
	`;

	return <StyledButton onClick={(e) => VXPay.openSignup()}>
		<Icon />{children}
	</StyledButton>;
}

function ButtonsBlock(props) {
	const {isLoggedIn, onLogoutClick} = props;

	const StyledBlock         = styled.div`
		float: right;
		height: 100%;
		
		${mediaMobile} {
			float: none;
			height: 50%;
		}		
	`;
	const StyledList          = styled.ul`
		margin: 0;
		padding: 0 7px 0 0;
		height: 100%;
		list-style-type: none;
		
		${mediaMobile} {
			width: 100%;
			height: 100%;
			display: inline-block;
			padding: 0;
		}		
	`;
	const StyledListItem      = styled.li`
		display: table;
		float: left;
		height: 100%;
		margin-left: 6px;
		
		${mediaMobile} {
			display: inline-block;
			float: none;
			width: 50%;
			margin-left: 0;
		}
	`;
	const StyledButtonWrapper = styled.div`
		display: table-cell;
		vertical-align: middle;

		${mediaMobile} {
			display: inline-block;
			width: 100%;
			height: 100%;
		}
	`;

	return <StyledBlock>
		<StyledList>
			{isLoggedIn && <StyledListItem>
				<StyledButtonWrapper>
					<LogoutButton onLogoutClick={onLogoutClick}>Abmelden</LogoutButton>
				</StyledButtonWrapper>
			</StyledListItem>}
			{!isLoggedIn && <StyledListItem>
				<StyledButtonWrapper>
					<SignupButtonDesktop>Kostenlos <b>Anmelden</b></SignupButtonDesktop>
					<SignupButtonMobile>Anmelden</SignupButtonMobile>
				</StyledButtonWrapper>
			</StyledListItem>}
			{!isLoggedIn && <StyledListItem>
				<StyledButtonWrapper>
					<LoginButton>Login</LoginButton>
				</StyledButtonWrapper>
			</StyledListItem>}
		</StyledList>
	</StyledBlock>;
}

const VXHeader = () => {
	return <AppConsumer>
		{({isLoggedIn, onLogoutClick}) => {
			const StyledNav = styled.nav`
					clear: both;
					height: 79px;
					border-bottom: 1px solid #FF4D3C;

				${mediaMobile} {
					height: ${!isLoggedIn ? '100px' : '50px'};
					text-align: center;
					border-bottom: none;
				}
			`;
			const Clear     = styled.div`
				clear: both;
			`;

			return <StyledNav>
				<Logo isLoggedIn={isLoggedIn} />
				{<ButtonsBlock isLoggedIn={isLoggedIn} onLogoutClick={onLogoutClick} />}
				<Clear />
			</StyledNav>;
		}}
	</AppConsumer>;
};

export default VXHeader;




// WEBPACK FOOTER //
// ./src/VXHeader.js